import React from 'react';
import { WiseFriendMark } from './WiseFriendMark';
import type { CompanionDefinition, CompanionMood } from './types';
import './Companion.css';

export const wiseFriendCompanion: CompanionDefinition = {
  id: 'wise-friend',
  displayName: 'Wise Friend',
  Artwork: WiseFriendMark,
};

export const defaultCompanion = wiseFriendCompanion;

export interface CompanionAvatarProps {
  mood?: CompanionMood;
  size?: number;
  mascot?: CompanionDefinition;
  className?: string;
  /** Omit when nearby text already conveys the meaning; the art is decorative. */
  label?: string;
}

export const CompanionAvatar: React.FC<CompanionAvatarProps> = ({
  mood = 'idle', size = 24, mascot = defaultCompanion, className, label,
}) => {
  const { Artwork } = mascot;
  return (
    <span
      className={['wf-companion-avatar', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size }}
      role="img"
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      data-companion={mascot.id}
    >
      <Artwork mood={mood} />
    </span>
  );
};
